/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ObserveModes } from '@typescript-kit/core';
import { ComponentData, ComponentModel, ComponentFieldKey } from '../model/component.model';
import { ViewComponentKey } from '../key/view-component.key';
import { TextModel } from './text.component-model';

export interface ContentData extends ComponentData {
  content?: ComponentData | string;
}

export class ContentFieldKey {
  static readonly CONTENT = 'content';
}

export class ContentModel extends ComponentModel implements ContentData {
  static readonly KEYS = ComponentModel.KEYS.concat(
    Object.keys(ContentFieldKey).map((key) => ContentFieldKey[key])
  );

  constructor(data?: ContentData, keys?: string[]) {
    super(data, keys || ContentModel.KEYS, { observeMode: ObserveModes.FLAT });
  }

  get content(): ComponentModel {
    return this.get(ContentFieldKey.CONTENT);
  }

  set content(value: ComponentModel) {
    this.set(ContentFieldKey.CONTENT, value);
  }

  protected createChildrenIterable(): Iterable<ComponentModel> {
    const self = this;
    return {
      [Symbol.iterator]: function* createChildrenGenerator() {
        if (self.content) {
          yield self.content;
        }
      }
    };
  }

  protected setupValues(values: ContentData, exclusive: boolean): ContentData {
    if (exclusive && !(ComponentFieldKey.TYPE in values)) {
      values.type = ViewComponentKey.CONTENT;
    }
    if (typeof values.content === 'string') {
      values.content = new TextModel({ text: values.content });
    }
    this.setupChild(ContentFieldKey.CONTENT, values, exclusive);
    return super.setupValues(values, exclusive) as ContentData;
  }

}
